export default __webpack_public_path__ + "static/media/logo-icon.ef699423.svg";